module.exports = __webpack_public_path__ + "static/media/deer-rudolph.0b4f183c.svg";